import React from 'react';
import { Table } from '@odin-labs/components';
import { useModalState } from 'utils';
import { AuthContext } from 'auth/authContext';
import {
  EditableShiftColumn,
  ScheduleShift,
  ScheduleWorkerModalValue,
} from 'containers/jobsite/tabs/jobsiteSchedules/data/types';
import {
  DeleteScheduleWorkerModal,
  EditScheduleWorkerModal,
  ViewNotesModal,
} from 'containers/jobsite/tabs/jobsiteSchedules/modals';
import { useJobsiteSchedules } from 'containers/jobsite/tabs/jobsiteSchedules/components/jobsiteSchedulesProvider';
import { getColumns } from './ScheduleWorkersTable.tables';

export function ScheduleWorkersTable(props: {
  shift: ScheduleShift;
}): React.ReactElement {
  const { shift } = props;

  const { currentUser: user } = React.useContext(AuthContext);
  const {
    value: scheduleWorkerModalValue,
    isModalOpen,
    openModal,
    closeModal,
    resetModalValue: resetScheduleWorkerModalValue,
  } = useModalState<ScheduleWorkerModalValue>(null);
  const { scheduleWorker, modalAction } = scheduleWorkerModalValue ?? {};

  const { isScheduleEditable, jobsiteId, selectedSchedule, loading } =
    useJobsiteSchedules();

  const columns = React.useMemo<EditableShiftColumn[]>(
    () => getColumns({ user, openModal, isScheduleEditable, jobsiteId }),
    [user, openModal, isScheduleEditable, jobsiteId],
  );

  const workers = React.useMemo(() => {
    return shift.workers.edges.map(({ node }) => node) ?? [];
  }, [shift]);

  return (
    <>
      <Table
        columns={columns}
        data={workers}
        disableGlobalFilter
        loadingRowCount={shift?.workers?.count ?? 5}
        loading={loading}
        remote
      />
      <ViewNotesModal
        isOpen={isModalOpen && modalAction === 'viewNotes'}
        closeModal={closeModal}
        onClosed={resetScheduleWorkerModalValue}
        scheduledWorker={scheduleWorker}
      />
      <EditScheduleWorkerModal
        editType="update"
        isOpen={isModalOpen && modalAction === 'edit'}
        closeModal={closeModal}
        onClosed={resetScheduleWorkerModalValue}
        selectedSchedule={selectedSchedule}
        scheduleWorker={scheduleWorker}
      />
      <DeleteScheduleWorkerModal
        isOpen={isModalOpen && modalAction === 'delete'}
        closeModal={closeModal}
        onClosed={resetScheduleWorkerModalValue}
        scheduledWorker={scheduleWorker}
      />
    </>
  );
}
